export const optionovaClerkAppearance = {
  variables: {
    colorPrimary: "#1f5b43",
    colorPrimaryForeground: "#ffffff",
    colorForeground: "#17372b",
    colorMutedForeground: "#66756e",
    colorBackground: "#fffdf8",
    colorInput: "#ffffff",
    colorInputForeground: "#17372b",
    colorBorder: "#d8dfda",
    colorRing: "#9dca42",
    borderRadius: "0.75rem",
    fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
  },
  elements: {
    rootBox: {
      width: "100%",
    },
    cardBox: {
      boxShadow: "none",
      width: "100%",
    },
    card: {
      background: "transparent",
      border: "0",
      boxShadow: "none",
    },
    footer: {
      borderRadius: "1rem",
      overflow: "hidden",
    },
    headerTitle: {
      display: "none",
    },
  },
} as const;
